import { render, staticRenderFns } from "./SlotPage.vue?vue&type=template&id=d1085714&scoped=true&"
import script from "./SlotPage.vue?vue&type=script&lang=js&"
export * from "./SlotPage.vue?vue&type=script&lang=js&"
import style0 from "./SlotPage.vue?vue&type=style&index=0&id=d1085714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1085714",
  null
  
)

export default component.exports